import React from 'react'

export default function H2(props) {
    return (
        <h2 className={`text-blue font-lato font-bold md:text-4xl text-3xl ${props.className}`}>
            {props.children}
        </h2>
    )
}
